import type { CalendarSystem, Lang } from "@calendar/shared";
import type { View } from "../store.js";

interface Props {
  displayName: string;
  year: number;
  years: number[];
  onYear: (year: number) => void;
  view: View;
  timeZone: string;
  calendar: CalendarSystem;
  lang: Lang;
  t: (key: string, vars?: Record<string, string | number>) => string;
  onView: (view: View) => void;
  onSave: (patch: { calendar?: CalendarSystem; lang?: Lang }) => void;
  onOpenSettings: () => void;
  onSignOut: () => void;
}

const VIEWS: View[] = ["year", "month", "week", "list", "search"];
const CALENDARS: CalendarSystem[] = ["jalali", "gregorian", "hijri"];
const LANGS: Lang[] = ["fa", "en"];

export function TopBar(props: Props) {
  const { view, calendar, lang, t, onView, onSave, onOpenSettings, onSignOut } = props;

  return (
    <header className="topbar">
      <div className="topbar__brand">
        <span aria-hidden="true">🗓</span>
        <span>Smart Calendar</span>
        <span className="signature">{props.displayName}</span>
      </div>
      <label className="year-picker glass">{lang === 'fa' ? 'سال' : 'Year'}
        <select className="select" value={props.year} aria-label={t('nav.year')} onChange={e=>props.onYear(Number(e.target.value))}>
          {props.years.map(year=><option key={year} value={year}>{year.toLocaleString(lang==='fa'?'fa-IR':'en-US',{useGrouping:false})}</option>)}
        </select>
      </label>

      <nav className="topbar__nav" aria-label={t("app.title")}>
        {VIEWS.map((v) => (
          <button key={v} type="button" aria-current={view === v} onClick={() => onView(v)}>
            {t("nav." + v)}
          </button>
        ))}
      </nav>

      <select
        className="select"
        style={{ width: "auto" }}
        value={calendar}
        onChange={(e) => onSave({ calendar: e.target.value as CalendarSystem })}
        aria-label={t("settings.calendar")}
      >
        {CALENDARS.map((c) => (
          <option key={c} value={c}>
            {t("calendar." + c)}
          </option>
        ))}
      </select>

      <select
        className="select"
        style={{ width: "auto" }}
        value={lang}
        onChange={(e) => onSave({ lang: e.target.value as Lang })}
        aria-label={t("settings.language")}
      >
        {LANGS.map((l) => (
          <option key={l} value={l}>
            {l === "fa" ? "فارسی" : "English"}
          </option>
        ))}
      </select>

      <button
        type="button"
        className="icon-btn"
        onClick={onOpenSettings}
        title={t("nav.settings")}
        aria-label={t("nav.settings")}
      >
        ⚙
      </button>
      <button
        type="button"
        className="icon-btn"
        onClick={onSignOut}
        title={t("action.logout")}
        aria-label={t("action.logout")}
      >
        ⏻
      </button>
    </header>
  );
}
